
import { GenericEntityBase, KeyType } from "../../_models/GenericEntityBase";
import { IPropretyAttribute, IEntityMetaData } from "../../_models/IEntityMetaData";
import { PropretyAttributes, Validation, NestedProperty, NavigationProperty } from "../../decorators/EntityDecorators";
import { i18nLanguage } from "./i18nLanguage.model";
import { FSTREAM_Image } from "./FSTREAM_Image.model";
import { BuzzerConfig } from "./BuzzerConfig.model";
import { EmployeePresenceInstance } from "./EmployeePresenceInstance.model";
import { Visit } from "./Visit.model";
import { Delivery } from "./Delivery.model";
import { EmployeePresenceTemplate_Employee } from "./navigation-entities/EmployeePresenceTemplate_Employee.model";
import { Evt_Employee } from "./navigation-entities/Evt_Employee.model";
import { RoomReservationInst_Emp } from "./navigation-entities/RoomReservationInst_Emp.model";
import { Employee_POS } from "./navigation-entities/Employee_POS.model";
import { Register } from "../../decorators/DependencyInjectionRegistreyDecorators";
import { RegexType } from "../../services/RegexPatternLibrary";


@Register({
  isModelEntity: true, namespace: 'Tenant', entityName: 'Employee' // optionnel car par defaut utilise le nom de classe
})
export class Employee extends GenericEntityBase<number> {
  @PropretyAttributes({
    attributes: [
      IPropretyAttribute.KeyProperty,
      IPropretyAttribute.Readonly
    ]
  })
  id: number = GenericEntityBase.GetDefaultId(KeyType.number);

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required, IPropretyAttribute.FilterColumn] })
  @Validation({
    propertyType: RegexType.Alphabetic,               
    minLength: 2,
    maxLength: 50
  })
  firstName!: string;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required, IPropretyAttribute.FilterColumn] })
  @Validation({
    propertyType: RegexType.Alphabetic,
    minLength: 2,
    maxLength: 50
  })
  lastName!: string;

  // Propriete composee cote modele C# : le serveur la reconstruit avec son separateur.
  @PropretyAttributes({ attributes: [IPropretyAttribute.SortColumn, IPropretyAttribute.FilterColumn] })
  @Validation({
    propertyType: RegexType.Alphabetic,
    minLength: 2,
    maxLength: 110
  })
  fullName: string = '';

  @Validation({
    propertyType: RegexType.Email
  })
  email?: string;

  @Validation({
    propertyType: RegexType.NorthAmericanPhone
  })
  phoneNumber?: string;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  status!: number;

  emailNotification?: boolean;

  slackNotification?: boolean;

  smsNotification?: boolean;

  teamsNotification?: boolean;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  fK_Language!: number;

  fK_Image_Photo?: number;

  emailTemp?: string;

  @Validation({ maxLength: 50 })
  phoneNumberTemp?: string;

  fK_Image_Photo_Temp?: number;

  isManager?: boolean;

  aDId?: string;

  fK_Manager?: number;

  @Validation({ maxLength: 50 })
  employeeID?: string;

  qrCode?: string;

  @NestedProperty({ TargetType: i18nLanguage })
  language?: i18nLanguage;

  @NestedProperty({ TargetType: FSTREAM_Image })
  imagePhoto?: FSTREAM_Image;

  @NestedProperty({ TargetType: FSTREAM_Image })
  imagePhotoTemp?: FSTREAM_Image;

  @NestedProperty({ TargetType: Employee })
  manager?: Employee;

  @NavigationProperty({ TargetType: Employee })
  managedEmployees?: Employee[];

  @NavigationProperty({ TargetType: BuzzerConfig })
  buzzerConfigs?: BuzzerConfig[];

  @NavigationProperty({ TargetType: Employee_POS })
  employeePOS?: Employee_POS[];

  @NavigationProperty({ TargetType: EmployeePresenceInstance })
  presenceInstances?: EmployeePresenceInstance[];

  @NavigationProperty({ TargetType: EmployeePresenceTemplate_Employee })
  presenceTemplateEmployees?: EmployeePresenceTemplate_Employee[];

  @NavigationProperty({ TargetType: Event })
  organizedEvents?: Event[];

  @NavigationProperty({ TargetType: Evt_Employee })
  eventEmployees?: Evt_Employee[];

  @NavigationProperty({ TargetType: RoomReservationInst_Emp })
  roomReservationEmployees?: RoomReservationInst_Emp[];

  @NavigationProperty({ TargetType: Visit })
  visits?: Visit[];

  @NavigationProperty({ TargetType: Visit })
  originVisits?: Visit[];

  @NavigationProperty({ TargetType: Delivery })
  deliveries?: Delivery[];

  @NavigationProperty({ TargetType: Delivery })
  pickupDeliveries?: Delivery[];

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  selectedPK_Pos: string[] = [];

  messages: Record<string, string> = {};

  GetType(): IEntityMetaData {
    return Employee.getMetaData();
  }
}
